import { render, staticRenderFns } from "./BuyTollFreeDid.vue?vue&type=template&id=3bfd92f0&scoped=true&"
import script from "./BuyTollFreeDid.vue?vue&type=script&lang=js&"
export * from "./BuyTollFreeDid.vue?vue&type=script&lang=js&"
import style0 from "./BuyTollFreeDid.vue?vue&type=style&index=0&id=3bfd92f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd92f0",
  null
  
)

component.options.__file = "BuyTollFreeDid.vue"
export default component.exports